import React from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { orderCreationSlice } from "../orderCreationSlice";

export const Success = () => {
  const dispatch = useDispatch();

  return (
    <>
      <h3 className="main-heading">Die Bestellung wurde verschickt!</h3>
      <div className="divider" />
      <p className="success-text">
        Die Bestellung wurde an uns weitergeleitet, sodass wir Dir zeitnah einen
        Lieferschein an Deine E-Mail Adresse zusenden.
        <br />
        <br />
        <strong>Deine nächsten Schritte für diese Bestellung</strong>
      </p>
      <ol>
        <li>Füge den Lieferschein der Bestellung hinzu</li>
        <li>Sende die Bestellung an den Markt</li>
        <li>Erstelle eine Rechnung inklusive der Lieferschein Belegnummer</li>
        <li>
          Sende die Rechnung als PDF an{" "}
          <a href="mailto:rechnungen.foodstarter@edeka.de">
            rechnungen.foodstarter@edeka.de
          </a>
        </li>
      </ol>
      <Button
        className="btn btn-secondary"
        onClick={() =>
          dispatch(orderCreationSlice.actions.resetOrderCreation())
        }
      >
        Weitere Bestellung anlegen
      </Button>
    </>
  );
};
